<template>
    <v-card>
        <v-card-title
        class="justify-center font-weight-bold"
        style="font-size: 30px;"
        >
         Bloquear Cliente
        </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6">
            <div style="font-size: 16px; margin-bottom: 10px;">
                <strong>Nome:</strong> {{ cliente.nome || 'Não informado' }}
            </div>
            </v-col>
            <v-col cols="12" sm="6">
            <div style="font-size: 16px; margin-bottom: 10px;">
                <strong>CPF:</strong> {{ cliente.cpf || 'Não informado' }}
            </div>
            <div style="font-size: 16px; margin-bottom: 10px;">
                <strong>Telefone:</strong> {{ cliente.telefone || 'Não informado' }}
            </div>
            <div style="font-size: 16px; margin-bottom: 10px;">
                <strong>Email:</strong> {{ cliente.email || 'Não informado' }}
            </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-select
                class="text-h6"
                label="Escolha os apps para bloquear"
                required
                outlined
                :items="projetos"
                item-text="projetos"
                item-value="projetos"
                v-model="projetosSelecionados"
                multiple
                :rules="[v => !!v || 'Selecione pelo menos um app']"
                @focus="carregarProjetos"
              ></v-select>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" dark class="text-h6 px-6" @click="confirmarBloqueio">
          Confirmar
        </v-btn>
        <v-btn color="red" text class="text-h6 px-6" @click="$emit('fechar')">
          Cancelar
        </v-btn>
      </v-card-actions>
    </v-card>
  </template>
<script>
export default {
  props: {
    cliente: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      projetos: [],
      projetosSelecionados: []
    }
  },
  watch: {
    cliente: {
      immediate: true,
      handler () {
        this.projetos = []
        this.projetosSelecionados = []
        this.carregarProjetos()
      }
    }
  },
  methods: {
    async carregarProjetos () {
      try {
        const pessoa = await this.$store.dispatch('verificarEmail', this.cliente.email)
        this.projetos = pessoa.projetos || []
        this.projetosSelecionados = pessoa.bloqueio_por_app || []
      } catch (error) {
        console.error('Erro ao buscar projetos:', error)
        this.$emit('erro', 'Erro ao buscar projetos.')
      }
    },
    async confirmarBloqueio () {
      try {
        await this.$store.dispatch('BloquearUsuario', {
          id_pessoa: this.cliente.id_pessoa,
          bloqueio_por_app: this.projetosSelecionados
        })
        const mensagem = this.projetosSelecionados.length === 0
          ? `Cliente ${this.cliente.nome} desbloqueado com sucesso.`
          : `Cliente ${this.cliente.nome} bloqueado com sucesso.`

        this.$emit('sucess', mensagem)
        this.$emit('fechar')
      } catch (error) {
        console.error('Erro ao bloquear cliente:', error)
        this.$emit('erro', 'Erro ao bloquear cliente.')
      }
    }
  }
}
</script>
